var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Divider",class:{empty: !_vm.text},on:{"click":function($event){_vm.clickCallback ? _vm.clickCallback() : function () {}}}},[_c('span',{staticClass:"inner"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }